module.exports = __webpack_public_path__ + "img/MASTER-VISUAL.f445d588.png";